import { makeStyles } from "@mui/styles";

const historyStyle = makeStyles((theme) => ({
  detailsContainer: {
    display: "flex",
    justifyContent: "center",
    width: "100% ",
    alignItems: "center",
    backgroundColor: theme.palette.background.gray,
    paddingLeft: '11.1rem',
    paddingRight: '11.1rem',
    [theme.breakpoints.down('lg')]: {
      paddingRight: '7.5rem',
      paddingLeft: '7.5rem',
    },
    [theme.breakpoints.down('sm')]: {
      paddingRight: '0rem',
      paddingLeft: '0rem',
    },
  },
  detailsSection: {
    backgroundColor: 'rgba(95, 89, 89, 0.16)',
    borderColor: 'rgba(95, 89, 89, 0.47)',
    borderRadius: "15px",
    paddingTop: '3rem',
    paddingRight: '4rem',
    paddingLeft: '4rem',
    paddingBottom: '1rem',
    alignItems: "center",
    boxShadow: "0px 8px 16px rgba(0,0,0,0.2)",
    animation: "$fadeInAnimation 1s ease-in-out forwards",
    [theme.breakpoints.down('lg')]: {
      paddingTop: "4rem",
      paddingBottom: "2rem",
    },
    [theme.breakpoints.down('sm')]: {
      paddingRight: '2rem',
      paddingLeft: '2rem',
      borderRadius: "40px",
    },
  },
  "@keyframes fadeInAnimation": {
    "0%": {
      opacity: 0,
      transform: "translateY(50px)",
    },
    "100%": {
      opacity: 1,
      transform: "translateY(0)",
    },
  },
  header: {
    fontSize: "1.8rem !important",
    marginBottom: "2rem !important",
    textAlign: "left",
    width: "100%",
    color: '#2b3a56',
    [theme.breakpoints.down('lg')]: {
      paddingTop:"0rem",
    },
    [theme.breakpoints.down('sm')]: {
      textAlign: "center",
      fontSize: "1.8rem!important",
    },
  },
  detailsRow: {
    display: "flex",
    alignItems: "center",
    gap: "4rem",
    width: "100%",
    marginBottom: "0.5rem",
    [theme.breakpoints.down("lg")]: {
      marginBottom: "2.5rem",
    },
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  imageContainer: {
    position: "relative",
    width: "45%",
    height: "300px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("lg")]: {
      width: "46%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      borderRadius: "15px",
    },
  },
  detailsImage: {
    width: "100%",
    height: "300px",
    backgroundSize: "cover",
    backgroundPosition: "center",
    borderRadius: "10px",
    backgroundRepeat: "no-repeat",
    [theme.breakpoints.down('sm')]: {
      width: "100%",
      borderRadius: "15px",
    },
  },
  imageCopyright: {
    position: "absolute",
    bottom: "8px",
    right: "10px",
    fontSize: "0.8rem",
    color: "#fff",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    padding: "4px 8px",
    borderRadius: "5px",
  },
  detailsText: {
    flex: 1,
    textAlign: "justify",
    color: '#2b3a56',
    [theme.breakpoints.down('sm')]: {
        paddingRight: "1rem",
        paddingLeft: "1rem",
    },
  },
  paragraph: {
    fontSize: "1.1rem!important",
    lineHeight: "1.5",
    textAlign: "justify",
    [theme.breakpoints.down('sm')]: {
        fontSize: "1.3rem!important",
    },
  },
  collapseButton: {
    marginTop: "1.5rem",
    color: "#2b3a56!important",
    border: "none",
    cursor: "pointer",
    index:1000,
    "& svg": {
      fontSize: "2.5rem!important",
    },
    "&:hover": {
        color: "#ffff!important",
      },
  },

}));

export default historyStyle;